module.exports = __webpack_public_path__ + "static/media/line-small-dashed.89b27a7c.svg";